function CognitiveAlerts({ alerts = [] }) {
  if (alerts.length === 0) return null;

  return (
    <div style={styles.wrapper}>
      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <div style={styles.badge}>VITA ENGINE</div>
          <h2 style={styles.title}>Alertas Cognitivas Automáticas</h2>
          <p style={styles.subtitle}>
            Generadas por el motor territorial en tiempo real. No requieren registro manual.
          </p>
        </div>
        <div style={styles.counter}>
          {alerts.length} alerta{alerts.length !== 1 ? 's' : ''} activa{alerts.length !== 1 ? 's' : ''}
        </div>
      </div>

      <div style={styles.list}>
        {alerts.map((alerta) => {
          const color = nivelColor[alerta.nivel] || nivelColor.Bajo;
          const icon = tipoIcon[alerta.tipo] || '!';

          return (
            <div
              key={alerta.id}
              style={{
                ...styles.card,
                borderLeft: `4px solid ${color.border}`
              }}
            >
              <div style={styles.cardTop}>
                <div style={{
                  ...styles.tipoBadge,
                  background: color.bg,
                  color: color.text,
                  border: `1px solid ${color.border}`
                }}>
                  {icon} {alerta.tipo}
                </div>
                <div style={{
                  ...styles.nivelBadge,
                  background: color.bg,
                  color: color.text
                }}>
                  {alerta.nivel}
                </div>
              </div>

              <div style={styles.cardTitulo}>{alerta.titulo}</div>
              <div style={styles.cardDesc}>{alerta.descripcion}</div>

              {alerta.actoresInvolucrados && (
                <div style={styles.actoresRow}>
                  {alerta.actoresInvolucrados.slice(0, 4).map((nombre, i) => (
                    <span key={i} style={styles.actorChip}>{nombre}</span>
                  ))}
                  {alerta.actoresInvolucrados.length > 4 && (
                    <span style={styles.actorChipMore}>
                      +{alerta.actoresInvolucrados.length - 4} más
                    </span>
                  )}
                </div>
              )}

              {alerta.ivt !== undefined && (
                <div style={styles.ivtBar}>
                  <div style={styles.ivtLabel}>IVT {alerta.ivt}%</div>
                  <div style={styles.ivtTrack}>
                    <div style={{
                      ...styles.ivtFill,
                      width: `${alerta.ivt}%`,
                      background: color.border
                    }} />
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

const nivelColor = {
  Crítico: {
    bg: 'rgba(220,38,38,0.08)',
    text: '#b91c1c',
    border: '#ef4444'
  },
  Alto: {
    bg: 'rgba(234,88,12,0.08)',
    text: '#c2410c',
    border: '#f97316'
  },
  Medio: {
    bg: 'rgba(202,138,4,0.08)',
    text: '#a16207',
    border: '#eab308'
  },
  Bajo: {
    bg: 'rgba(100,116,139,0.08)',
    text: '#475569',
    border: '#94a3b8'
  }
};

const tipoIcon = {
  ESCALAMIENTO: '>>',
  ACTIVACIÓN: '>',
  CONVERGENCIA: '~'
};

const styles = {
  wrapper: {
    background: 'white',
    borderRadius: '20px',
    padding: '28px',
    marginBottom: '24px',
    boxShadow: '0 8px 25px rgba(0,0,0,0.08)',
    border: '1px solid #fee2e2'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '22px',
    gap: '20px'
  },
  headerLeft: { flex: 1 },
  badge: {
    display: 'inline-block',
    background: 'linear-gradient(135deg,#1fa97a,#0993b5)',
    color: 'white',
    padding: '4px 12px',
    borderRadius: '999px',
    fontSize: '10px',
    fontWeight: '900',
    letterSpacing: '1px',
    marginBottom: '10px'
  },
  title: {
    margin: '0 0 6px',
    fontSize: '22px',
    color: '#071a2f'
  },
  subtitle: {
    margin: 0,
    color: '#667085',
    fontSize: '13px'
  },
  counter: {
    background: '#fef2f2',
    color: '#b91c1c',
    border: '1px solid #fecaca',
    padding: '10px 16px',
    borderRadius: '999px',
    fontWeight: '900',
    fontSize: '13px',
    whiteSpace: 'nowrap'
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px'
  },
  card: {
    background: '#fafafa',
    borderRadius: '14px',
    padding: '18px',
    border: '1px solid #f1f5f9'
  },
  cardTop: {
    display: 'flex',
    gap: '10px',
    marginBottom: '10px',
    alignItems: 'center'
  },
  tipoBadge: {
    padding: '4px 12px',
    borderRadius: '999px',
    fontSize: '11px',
    fontWeight: '900',
    letterSpacing: '0.5px'
  },
  nivelBadge: {
    padding: '4px 10px',
    borderRadius: '999px',
    fontSize: '11px',
    fontWeight: '700'
  },
  cardTitulo: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#071a2f',
    marginBottom: '6px'
  },
  cardDesc: {
    fontSize: '13px',
    color: '#475467',
    lineHeight: '1.6',
    marginBottom: '10px'
  },
  actoresRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
    marginBottom: '10px'
  },
  actorChip: {
    background: '#eef4ff',
    color: '#1849a9',
    padding: '4px 10px',
    borderRadius: '999px',
    fontSize: '12px',
    fontWeight: '600'
  },
  actorChipMore: {
    background: '#f1f5f9',
    color: '#64748b',
    padding: '4px 10px',
    borderRadius: '999px',
    fontSize: '12px'
  },
  ivtBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginTop: '4px'
  },
  ivtLabel: {
    fontSize: '12px',
    fontWeight: '700',
    color: '#344054',
    whiteSpace: 'nowrap'
  },
  ivtTrack: {
    flex: 1,
    height: '6px',
    background: '#e4e7ec',
    borderRadius: '999px',
    overflow: 'hidden'
  },
  ivtFill: {
    height: '100%',
    borderRadius: '999px',
    transition: 'width 0.3s ease'
  }
};

export default CognitiveAlerts;